/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrderByProvidersEnum {
    ID = 'id',
    NAME = 'name',
    DESCRIPTION = 'description',
    IS_ACTIVE = 'is_active',
}
